import { get } from '../../request';
const PUB_KEY_API = '//ut.xiaojukeji.com/ut/janitor/api/common/ciphersuite/get';
const state = {
    publicKey: null
};
/**
 * 获取加密公钥
 * @returns Public Key
 */
export const getEncryptPublicKey = async () => {
    if (!state.publicKey) {
        const { errno, data } = await get(PUB_KEY_API);
        if (Number(errno) === 0) {
            state.publicKey = data.public_key;
        }
        else {
            throw new Error('failed to getEncryptPublicKey');
        }
    }
    return state.publicKey;
};
